{
  "title": "Мониторинг",
  "intro": "Все серверы проекта по данным Автопилота: сначала те, что требуют внимания. Цифры — из последнего отчёта агента, обновляются каждую минуту. Нажмите на сервер, чтобы открыть его вкладку «Автопилот».",
  "actions": {
    "alerts": "Оповещения проекта",
    "enable": "Включить",
    "enableFor": "Включить Автопилот на {{name}}"
  },
  "tiles": {
    "label": "Сводка по проекту",
    "watched": "С Автопилотом, из {{total}}",
    "critical": "Требуют внимания",
    "problems": "С проблемами",
    "alerts": "Активных оповещений",
    "securityUpdates": "Обновлений безопасности",
    "off": "Без Автопилота"
  },
  "filter": {
    "label": "Поиск сервера",
    "placeholder": "Имя или IP-адрес",
    "state": "Состояние",
    "options": {
      "all": "Все серверы",
      "problems": "С проблемами",
      "critical": "Требуют внимания",
      "notReporting": "Без отчётов",
      "off": "Без Автопилота",
      "updates": "Есть обновления"
    },
    "noMatch": "Таких серверов нет."
  },
  "empty": {
    "title": "В проекте пока нет серверов",
    "text": "Создайте сервер с Автопилотом — здесь появятся его нагрузка, сервисы, контейнеры и предупреждения."
  },
  "columns": {
    "server": "Сервер",
    "state": "Состояние",
    "alerts": "Оповещения",
    "cpu": "CPU",
    "memory": "Память",
    "disk": "Диск",
    "load": "Нагрузка",
    "services": "Сервисы",
    "containers": "Контейнеры",
    "updates": "Обновления",
    "certificates": "Сертификаты",
    "agent": "Агент"
  },
  "cells": {
    "off": "Автопилот выключен",
    "alertsOf": "Оповещений: {{count}} — открыть оповещения {{name}}",
    "loadPerCore": "{{load}} на ядро",
    "servicesFailed": "с ошибкой: {{count}}",
    "servicesOk": "работают все ({{total}})",
    "containersOff": "не отслеживаются",
    "containers": "работают {{running}} из {{total}}",
    "containerProblems": "с проблемами: {{count}}",
    "updatesNone": "нет",
    "updatesSecurity": "безопасности: {{count}}",
    "updatesTotal": "всего: {{count}}",
    "certificatesNotCollected": "пока не собираются",
    "certificatesExpired": "истекли: {{count}}",
    "certificatesExpiring": "скоро истекут: {{count}}",
    "certificatesNext": "ближайший до {{date}}"
  },
  "update": {
    "badge": "Есть новая версия",
    "action": "Обновить",
    "actionFor": "Обновить агент на {{name}}",
    "summary": "Новая версия агента есть для серверов: {{count}}. Агент сам не обновляется — нажмите «Обновить» и выполните команду установки ещё раз, история метрик сохранится.",
    "notice": "Есть новая версия агента: {{version}}. Агент сам не обновляется: получите команду установки и выполните её ещё раз — история метрик сохранится.",
    "noticeAction": "Получить команду"
  }
}
